import ViewComponent from "~/components/pages/supervisor/worklist/view";

export default function ViewPage() {
  return (
    <div>
      <ViewComponent />
    </div>
  );
}
